/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

      $("#header > .wrapper").first().wrap( "<div class='fixed-wrapper'></div>" );


        // JavaScript to be fired on all pages

        var $mmenu = $('#navigation-main'),$html = $('html, body');

       $mmenu.mmenu({

         extensions: ["theme-white", "pagedim-black", "effect-slide-menu", "effect-listitems-slide","border-full"],
         offCanvas: {
           moveBackground: false,
           position: "left",
           zposition : "front"
         },
         navbar: {
           add: false
         },
         navbars: [
           {
               position: "top",
               content: [ '' ]
             }
         ],
         slidingSubmenus: false
     }, {

         offCanvas: {
           pageSelector: "> div:not(#wpadminbar)"
         },
         clone:true
       }).removeClass('invisible');

	     try{



        $("#mm-navigation-main #mm-1 ul").append('<li id="notdienst_btn" class="notdienst ext"></li>');
        $("#mm-navigation-main #mm-1 ul").append('<li id="cart_btn" class="cart ext"></li>');
        $("#mm-navigation-main #mm-1 ul").append('<li id="fb_btn" class="facebook ext"></li>');
      
        $("a.notdienst").clone().appendTo("#notdienst_btn");

        if ($("#services a.facebook").length > 0) {
          $("#mm-navigation-main #mm-1 ul").append('<li id="fb_btn" class="facebook ext"></li>');
          $("#services a.facebook").clone().appendTo("#fb_btn");
        }
        if ($("#footer a.whatsapp").length > 0) {
          $("#mm-navigation-main #mm-1 ul").append('<li id="whatsapp_btn" class="whatsapp1 ext"></li>');
          $("#footer a.whatsapp").clone().appendTo("#whatsapp_btn");
        }
        if ($("#footer a.vcard").length > 0) {
          $("#mm-navigation-main #mm-1 ul").append('<li id="vcard_btn" class="vcard1 ext"></li>');
          $("#footer a.vcard").clone().appendTo("#vcard_btn");
        }
        if ($("#services a.skype").length > 0) {
          $("#mm-navigation-main #mm-1 ul").append('<li id="skype_btn" class="skype ext"></li>');
          $("#navigation-main a.skype").clone().appendTo("#skype_btn");
        }



        var cart_mob=$("a#cart").clone();
		cart_mob.attr("id","cart-mob").appendTo("#cart_btn");


      }catch(err){
        $.noop();
      }

      /* var API = $('#mm-navigation-main').data( "mmenu" );

     $('#mm-navigation-main').find( 'li:not(.ext) > a' ).on('click',function(event){
                     var hlink = $(this).attr( 'href' );


                        API.bind( "closed", function() {

                 setTimeout(function(){

                 $.scrollTo(hlink, 650, { easing: 'easeInOutExpo' , offset: -120 , 'axis':'y' },10);
                 hlink=null;

                   });
                 });

     });*/

      /*$("#navigation-main a").each(function(index1){
          $(this).click(function(e){
          //return false;
          });
      });



      $("#navigation-main li:not(.ext)").each(function(index){
        $(this).click(function(e){
         e.preventDefault();
         $(this).siblings().removeClass("current-menu-item");
         $(this).addClass("current-menu-item");
         $.scrollTo($(this).find("a").attr("href"), 850, { easing: 'easeInOutExpo' , offset: -140 , 'axis':'y' },10);
        });
      });*/

      try{
               $('[data-toggle="popover"]').popover();
            }catch(err){
              $.noop();
            }


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        try{

        $(document).on('scroll', function () {
            // if the scroll distance is greater than 100px

            if ($(window).scrollTop() > 50) {
              // do something
              $('header').addClass("scrolled");

            }else{
            $('header').removeClass("scrolled");

            }
        });


           }catch(e){
             $.noop();
           }

           try{
              $('.gmaps-wrapper iframe').css("pointer-events", "auto");
           }catch(err){
             $.noop();
           }

      }
    },
    // Home page
    'home': {
      init: function() {
        try{
          $('.header-carousel').slick({   dots: true,arrows:false,   infinite: true,   speed: 900,   slidesToShow: 1,   adaptiveHeight: true,autoplay: true,
          autoplaySpeed: 4000,
            responsive: [
              {
                breakpoint: 980,
                settings: {
                  arrows: false,
                  dots:false
                }
              }
            ]

         });
        }catch(err){
          $.noop();
        }

        // JavaScript to be fired on the home page

        $('.teaser-carousel').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite:true,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: false,
        slidesToShow: 4,
        dots:true
      }
    },
    {
      breakpoint: 950,
      settings: {
        arrows: false,
        slidesToShow: 3,
        dots:true
      }
    },
    {
      breakpoint: 650,
      settings: {
        arrows: false,
        slidesToShow: 2,
        dots:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 1,
        dots:true
      }
    }
  ]
});
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'ueber_uns': {
      init: function() {
        // JavaScript to be fired on the about us page
        $('.teaser-carousel').slick({
  centerMode: true,
  centerPadding: '60px',
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 950,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '10px',
        slidesToShow: 1
      }
    }
  ]
});
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
